import { IconButton } from '@ctct/ui-react';

import { useDiscountCodeContext } from '../DiscountCodeContext';

const DiscountCodeApplied = () => {
  const { handleRemove, formattedDiscountAmount, formattedDiscountCode } = useDiscountCodeContext();

  return (
    <div className="discount-code-container__discount-applied-container">
      <IconButton
        className="discount-code-container__discount-applied_remove-btn"
        size="small"
        title="remove"
        glyph="closeCircle"
        onClick={handleRemove}
      />
      <span className="discount-code-container__discount-applied_discount-name">{formattedDiscountCode}</span>
      <span className="discount-code-container__discount-applied_discount-amount">{formattedDiscountAmount}</span>
    </div>
  );
};

export default DiscountCodeApplied;
